// Mobile sticky "Add to cart" bar for the product page.
// Zero duplication of cart logic: the sticky button simply requestSubmit()s
// the real, native product form (Dawn's product-form.js / cart AJAX handle
// everything else exactly as it already does for the main button).
(function () {
  if (window.__pdpStickyInit) return;
  window.__pdpStickyInit = true;

  function init(bar) {
    var root = bar.closest('product-info') || document;
    var formId = bar.getAttribute('data-form-id');
    var targetId = bar.getAttribute('data-target-id');
    if (!formId || !targetId) return;

    var target = root.querySelector('#' + targetId);
    if (!target) return;

    var submitBtn = bar.querySelector('[data-pdp-sticky-atc-submit]');
    if (!submitBtn) return;

    function syncDisabledState() {
      var disabled = target.disabled || target.getAttribute('aria-disabled') === 'true';
      submitBtn.disabled = disabled;
      submitBtn.classList.toggle('pdp-sticky-atc__button--disabled', disabled);
    }

    submitBtn.addEventListener('click', function () {
      var form = document.getElementById(formId);
      if (form && typeof form.requestSubmit === 'function') {
        form.requestSubmit();
      } else {
        target.click();
      }
    });

    syncDisabledState();

    if ('MutationObserver' in window) {
      var mo = new MutationObserver(syncDisabledState);
      mo.observe(target, { attributes: true, attributeFilter: ['disabled', 'aria-disabled'] });
    }

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            bar.hidden = entry.isIntersecting;
          });
        },
        { rootMargin: '0px 0px -15% 0px', threshold: 0 }
      );
      observer.observe(target);
    }
  }

  document.querySelectorAll('[data-pdp-sticky-atc]').forEach(init);
})();
